<template>
    <div
        class="list-item-wrap"
        :style="{
            marginLeft: index % 2 == 1 ? '3%' : 0,
            marginTop: index / 2 >= 1 ? '0.5rem' : ''
        }"
        @click.stop="$emit('item-click', data)"
    >
        <img class="item-img" :src="data.cover" alt="" />
        <p class="item-title">{{ data.title }}</p>
        <div class="item-data">
            <span v-if="data.file_type == 2" class="item-sign">视频</span>
            <span v-if="data.file_type == 9" class="item-sign">文章</span>
            <div class="item-data-item">
                <img class="item-data-img" src="@/assets/images/item_view.png" alt="" />
                <p class="item-data-text">{{ data.view_num }}</p>
            </div>
            <div class="flex-1"></div>
            <div class="item-data-item mr-30">
                <img class="item-data-img" src="@/assets/images/item_thumbsup.png" alt="" />
                <p class="item-data-text">{{ data.praise_num }}</p>
            </div>
            <div class="item-data-item">
                <img
                    class="item-data-img"
                    src="@/assets/images/item_comment.png"
                    alt=""
                    style="margin-top: 0"
                />
                <p class="item-data-text">{{ data.comment_num }}</p>
            </div>
        </div>
    </div>
</template>
<script>
export default {
    components: {},
    props: {
        data: Object,
        index: Number
    },
    data() {
        return {}
    },
    computed: {},
    created() {},
    mounted() {},
    methods: {}
}
</script>

<style>
p {
    margin-block-start: 0;
    margin-block-end: 0;
}
</style>
<style scoped>
.list-item-wrap {
    position: relative;
    display: flex;
    flex-direction: column;
    align-items: center;
    width: 47.6%;
    height: 6.83rem;
    background-color: #ffffff;
    box-shadow: 0px 4px 16px 0px rgba(206, 206, 206, 0.4);
    border-radius: 0.3rem;
    border: solid 0.02rem #ececec;
    cursor: pointer;
}

.item-img {
    width: 100%;
    height: 4.05rem;
    border-radius: 0.21rem 0.21rem 0rem 0rem;
}

.item-title {
    box-sizing: border-box;
    width: 100%;
    height: 1.6rem;
    line-height: 0.75rem;
    margin-top: 0.17rem;
    font-size: 0.55rem;
    font-weight: bold;
    color: #222222;
    overflow: hidden;
    padding: 0 0.43rem;
    word-wrap: break-word;
}

@media all and (-ms-high-contrast: none), (-ms-high-contrast: active) {
    .item-title {
        font-size: 0.5rem;
        line-height: 0.55rem;
    }
}

.item-data {
    box-sizing: border-box;
    display: flex;
    flex-direction: row;
    align-items: center;
    width: 100%;
    padding: 0 0.43rem;
}
.item-sign {
    position: absolute;
    top: 0;
    right: 0;
    width: 1.78rem;
    height: 0.88rem;
    line-height: 0.88rem;
    text-align: center;
    background: rgba(18, 68, 241, 0.8);
    border-radius: 0px 0.3rem 0px 4px;
    font-size: 0.6rem;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #ffffff;
}
.item-data-item {
    display: flex;
    flex-direction: row;
    align-items: center;
}

.item-data-img {
    margin-top: -0.1rem;
    width: 0.6rem;
}

.item-data-text {
    width: 1.1rem;
    margin-left: 0.1rem;
    font-size: 0.47rem;
    color: #888888;
}

.flex-1 {
    flex: 1;
}

.ml-42 {
    margin-left: 0.42rem;
}

.mr-42 {
    margin-right: 0.42rem;
}

.mr-30 {
    margin-right: 0.3rem;
}
</style>